import { useEffect, useRef, useState } from 'react';
import DatadogService from '@shared/services/datadog';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import updateLocale from 'dayjs/plugin/updateLocale'
import i18n from '@src/i18n';

import en from 'dayjs/locale/en';
import de from 'dayjs/locale/de';
import fr from 'dayjs/locale/fr';
import pl from 'dayjs/locale/pl';
import ro from 'dayjs/locale/ro';
import bg from 'dayjs/locale/bg';
import it from 'dayjs/locale/it';
import nl from 'dayjs/locale/nl';
import pt from 'dayjs/locale/pt';
import sk from 'dayjs/locale/sk';
import tr from 'dayjs/locale/tr';
import { useTranslation } from 'react-i18next';

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.extend(updateLocale);
dayjs.extend(utc)


const useEtaBack = () => {
    const { t } = useTranslation();
    const [eta, setEta] = useState('');
    const localeManifest = [en.name, de.name, fr.name, pl.name, ro.name, bg.name, it.name, nl.name, pt.name, sk.name, tr.name];
    const ETAHasPassedEventSentToDatadog = useRef<Boolean>(false)

    useEffect(() => {
        dayjs.locale(localeManifest.includes(i18n.language) ? i18n.language : en);
    }, [i18n.language]);

    const getDistanceDuration = (date: any) => {
        const now = dayjs().toJSON();
        if (date) {
            if (dayjs(date).isBefore(dayjs().utc().format())) {
                /*  console.log('sasa', { 'server': date, 'now': dayjs().utc().format() }) */
                if (!ETAHasPassedEventSentToDatadog.current) {
                    DatadogService.createError('ETA_HAS_PASSED', { type: 'ETA Calculation', message: `ETA has passed but courier still on the way.` });
                    ETAHasPassedEventSentToDatadog.current = true
                }
                return t('courier.returningToRestaurant')
            } else {
                const date1 = dayjs(now).to(dayjs(date));
                return `${t('courier.backBy')} ${date1}`
            }
        }
        else {
            return t('courier.returningToRestaurant')
        }
    };

    return { getDistanceDuration, eta, setEta };
};

export default useEtaBack;
